import React, { Component } from 'react';
import { Button, Popconfirm, message } from 'antd';
import UpdateModal from './UpdateSystemExp';
import ComTable from '../ComTable';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class SystemExp extends Component {
    state = {
        data: [],
        config: [],
        pagination: {
            offset: 1,
            pageSize: 10,
        },
        loading: false,
    }

    componentDidMount() {
        const config = [{
            zh: '系统类型',
            en: 'System Type',
            key: 'systemType',
            width: 200,
        }, {
            zh: '系统名称',
            en: 'System Name',
            key: 'systemName',
        }, {
            zh: '公司名称',
            en: 'Company Name',
            key: 'companyName',
            width: 300,
        }];
        this.setState({ config }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { userId, isChinese } = this.props;
        const { pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.querySystemExperience,
            data: {
                userId,
                offset: current,
                limit: pageSize,
                type: isChinese ? 'CHINESE' : 'ENGLISH',
            },
            dataType: 'json',
            doneResult: res => {
                const { systemExperienceList = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                this.setState({
                    pagination,
                    loading: false,
                    data: systemExperienceList,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    update = (record) => {
        this.ref.show(record);
    }

    delete = (row) => {
        const { vitaeSystemExperienceId } = row;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.delSystemExperience,
            data: { vitaeSystemExperienceId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleTableChange = ({ pagination }) => {
        this.setState({ pagination }, () => {
            this.loadData();
        });
    }

    getOperate = () => {
        const { isChinese } = this.props;
        return {
            title: isChinese ? '操作' : 'Operation',
            key: 'operate',
            width: 80,
            render: (text, row) => {
                return (
                    <span>
                        <a onClick={() => this.update(row)}>修改</a>
                        {
                            isChinese ? 
                                <span>
                                    <span className="ant-divider" />
                                    <Popconfirm title="确定要删除吗?" onConfirm={() => this.delete(row)}>
                                        <a>删除</a>
                                    </Popconfirm>
                                </span>
                            :
                             null
                        }
                    </span>
                );
            }
        };
    }

    getDataSource = () => {
        const { data } = this.state;
        const { isChinese } = this.props;
        const dataSource = data.map((item, index) => {
            const {
                systemTypeChinese,                      // 系统类型备注
                systemTypeEnglish,                      
                systemNameChinese,                      // 系统名称（系统类型选其他时）
                systemNameEnglish, 
                companyNameChinese,
                companyNameEnglish,
                systemExperienceTypeChineseName,        // 系统类型name
                systemExperienceTypeEnglishName,
                systemExperienceNameChineseName,        // 系统名称name
                systemExperienceNameEnglishName,
                systemNameCommentsChinese,              // 系统名称备注
                systemNameCommentsEnglish,
            } = item;
            const systemType = isChinese ? systemExperienceTypeChineseName : systemExperienceTypeEnglishName;
            const systemTypeComments = isChinese ? systemTypeChinese : systemTypeEnglish;
            const systemName = isChinese ? (systemNameChinese || systemExperienceNameChineseName) : (systemNameEnglish || systemExperienceNameEnglishName);
            const systemNameComments = isChinese ? systemNameCommentsChinese : systemNameCommentsEnglish;
            return {
                index: index + 1,
                ...item,
                systemType: `${systemType}${systemTypeComments ? `(${systemTypeComments})` : ''}`,
                systemName: `${systemName}${systemNameComments ? `(${systemNameComments})` : ''}`,
                companyName: isChinese ? companyNameChinese : companyNameEnglish,
            }
        });
        return dataSource;
    }

    render() {
        const { userId, canEdit, isChinese } = this.props;
        const { data, config, loading, pagination } = this.state;
        const result = config.map(item => {
            if (isChinese) {
                item.title = item.zh;
            } else {
                item.title = item.en;
            }
            return item;
        });
        canEdit && result.push(this.getOperate());
        return (
            <div>
                { canEdit && isChinese && <Button type="primary" onClick={() => this.update()}>新增</Button> }
                <div style={{ marginTop: 20 }}>
                    <ComTable
                        data={data}
                        config={result}
                        loading={loading}
                        pagination={pagination}
                        getDataSource={this.getDataSource}
                        onChange={(params) => this.handleTableChange(params)}
                    />
                </div>
                <UpdateModal ref={el => this.ref = el} userId={userId} isChinese={isChinese} loadData={this.loadData} />
            </div>
        );
    }
}

export default SystemExp;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/SystemExp.js